import { useMsal } from "@azure/msal-react";
import {
 Button,
 FormControl,
 FormControlLabel,
 FormLabel,
 ListSubheader,
 MenuItem,
 Radio,
 RadioGroup,
 Select,
 Stack,
 TextField,
 Typography,
 styled,
 Modal,
 Box,
 Autocomplete,
 Grid
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import axios from "axios";
import React, { useState } from "react";
import { baseURL } from "../Constant";
import "./CampaignForm.css";
import { useSelector } from "react-redux";

const WhiteBorderTextField = styled(TextField)`
 & label.Mui-focused {
  color: #a804ff;
 }
 & .MuiOutlinedInput-root {
  &.Mui-focused fieldset {
   border-color: #a814ff;
   border-width: 1px;
  }
 }
`;

const marketOrTrackList = [
 {
  group: "Market",
  sub_list: [
   "ATCI",
   "EMEA",
   "Americas",
   "GM",
   "ATC Global Network",
   "ATCI Song",
   "Cloud",
   "AI",
   "E&IT",
   "I&D",
   "Delivery",
   "BI&HS",
   "Language & Culture Academy",
   "L&TT",
   "LIS",
   "L&TT Ops",
   "LDE NeXT",
  ],
 },
 {
  group: "6 specialized Practices",
  sub_list: [
   "Enterprise Platforms",
   "Cloud First",
   "Data & AI",
   "Security",
   "Infrastructure Engineering",
   "Software & Platform Engineering",
  ],
 },
 {
  group: "5 Technology Industry Practices",
  sub_list: [
   "Communications/Media/Technology",
   "Financial Services",
   "Health/Public Service",
   "Products",
   "Resources",
  ],
 },
];

const CampaignForm = ({ setCMD, setL2 ,typeOfUser}) => {
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 let loggedInEnterpriseId = "";
 if (activeAccount) {
  loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
 }

 const {UserMaintanenceData}= useSelector((state)=> state.userRoles);

 const weekAhead = () => {
  let todayPlus15 = new Date();
  // let workingDays = 0;

  // // Increment the date until 5 working days are added
  // while (workingDays < 5) {
  //  todayPlusWeek.setDate(todayPlusWeek.getDate() + 1);

  //  // Only count weekdays (Monday to Friday)
  //  if (todayPlusWeek.getDay() >= 1 && todayPlusWeek.getDay() <= 5) {
  //   workingDays++;
  //  }
  // }
  todayPlus15.setDate(todayPlus15.getDate() + 15);

  // Return formatted 'YYYY-MM-DD' string
  return todayPlus15.toISOString().split("T")[0];
 };

 const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
 ))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
   backgroundColor: "#f5f5f9",
   color: "rgba(0, 0, 0, 0.87)",
   maxWidth: 220,
   fontSize: theme.typography.pxToRem(12),
   border: "1px solid #dadde9",
  },
 }));

 const [campaignName, setCampaignName] = useState("");
 const [startDate, setStartDate] = useState("");
 const [endDate, setEndDate] = useState("");
 const [campaignType, setCampaignType] = useState("Learning Program");
 const [selectedMarket, setSelectedMarket] = useState("");
 const [targetAudience, setTargetAudience] = useState("");
 const [peopleTargeted, setPeopleTargeted] = useState(null);
 const [isVerified, setIsVerified] = useState(false);
 const [openModal,setOpenModal]= useState(false);
 const [inputValue, setInputValue] = useState('');
 const [onBehalfValue, setOnBehalfValue] = useState('');

 const handleSubmit = (e) => {
  e.preventDefault();

  const selectedStartDate = new Date(startDate);
  const selectedEndDate = new Date(endDate);

  if (selectedEndDate <= selectedStartDate) {
   alert("End date must be later than the start date.");
   return;
  }

  setCMD({
   id: -1,
   name: campaignName,
   requestorId: loggedInEnterpriseId,
   startDate,
   endDate,
   type: campaignType,
   market: selectedMarket, // Add selected market from dropdown
   target_audience: targetAudience, // Add target audience from text input
   people_targeted: Number(peopleTargeted), // Add number of people targeted from number input
   onBehalf_of: onBehalfValue
  });
  setL2(campaignName);
 };

 const handleNameChange = (e) => {
  setCampaignName(e.target.value);
  setIsVerified(false);
 };

 const handleVerify = async (e) => {
  e.preventDefault();

  try {
   const response = await axios.get(`${baseURL}/campaignWithName/${campaignName}`);
   if (response.status === 200 || response.status === 201) {
    setIsVerified(true);
   } else if (response.status === 202 || response.status === 203) {
    console.log(response);
    alert(`Error: ${response.data.message}. Please enter a unique name to proceed.`);
   }
  } catch (err) {
   console.log("Error in verifying: ", err);
   alert(`Error: Failed to verify Campaign name. Please enter a unique name to proceed.`);
  }
 };

 const handleBehalfUserSet =()=>{
   setOpenModal(false);
   setOnBehalfValue(onBehalfValue);
 }

 return (<>
  <Stack
   spacing={1}
   component="form"
   onSubmit={handleSubmit}
   className="mail-form-container-stack"
  >
   <div className="mail-form-container">
    <div className="mailer-form-categories-section">
     <FormLabel component="legend">Campaign Type</FormLabel>
     <RadioGroup
      row
      aria-label="campaign-type"
      name="campaignType"
      value={campaignType}
      onChange={(e) => setCampaignType(e.target.value)}
     >
      <FormControlLabel
       value="Learning Program"
       control={<Radio />}
       label="Learning Program"
      />
      <FormControlLabel value="Event" control={<Radio />} label="Event" />
      <FormControlLabel
       value="Microsite/Tool/Platform"
       control={<Radio />}
       label="Microsite/Tool/Platform"
      />
      <FormControlLabel value="Webinar" control={<Radio />} label="Webinar" />
     </RadioGroup>
    </div>
    <div className="mail-form-wrap">
     <Stack
      className="mail-form-headers"
      sx={{
       display: "flex",
       flexDirection: "column",
       gap: "10px",
       marginBottom: "10px",
      }}
     >
      <Typography sx={{ fontSize: "16px" }}>
       <span>
        Name<span style={{ color: "red" }}>*</span>
       </span>
       <HtmlTooltip arrow title="Enter a unique Campaign Name and click verify.">
        <img
         src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
         style={{ width: "3%", cursor: "pointer" }}
        />
       </HtmlTooltip>
      </Typography>
      <WhiteBorderTextField
       fullWidth
       placeholder="Eg:Java Hackathon."
       // variant="outlined"
       value={campaignName}
       onChange={handleNameChange}
       required
       // id="multiline"
       multiline
       minRows={1}
       maxRows={2}
       InputProps={{
        endAdornment: (
         <Button
          sx={{color:"#AB25FB",textTransform:"none",fontWeight:"bold"}}
          size="small"
          onClick={handleVerify}
          disabled={campaignName === "" || isVerified}
         >
          Verify
         </Button>
        ),
       }}
       InputLabelProps={{ shrink: false }}
      />
     </Stack>
     <Stack
      className="mail-form-headers"
      sx={{
       display: "flex",
       flexDirection: "column",
       gap: "10px",
       marginBottom: "10px",
      }}
     >
      <Typography sx={{ fontSize: "16px" }}>
       <span>
        Market/Track<span style={{ color: "red" }}>*</span>
       </span>
       <HtmlTooltip arrow title="Select the market or track which applies.">
        <img
         src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
         style={{ width: "3%", cursor: "pointer" }}
        />
       </HtmlTooltip>
      </Typography>
      <FormControl fullWidth>
       <Select
        labelId="market-select-label"
        id="market-select"
        value={selectedMarket}
        onChange={(e) => setSelectedMarket(e.target.value)}
        required
       >
        {marketOrTrackList.map((group, index) => [
         <ListSubheader key={`group-${index}`}>{group.group}</ListSubheader>,
         group.sub_list.map((item, subIndex) => (
          <MenuItem key={`item-${index}-${subIndex}`} value={item}>
           {item}
          </MenuItem>
         )),
        ])}
       </Select>
      </FormControl>
     </Stack>
     <div className="mail-form-inner-wrap">
      <Stack
       className="mail-form-headers"
       sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginBottom: "10px",
       }}
      >
       <Typography sx={{ fontSize: "16px" }}>
        <span>
         Start Date<span style={{ color: "red" }}>*</span>
        </span>
        <HtmlTooltip
         arrow
         title="Start Date should be atleast 15 days ahead of the current date"
        >
         <img
          src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
          style={{ width: "6%", cursor: "pointer" }}
         />
        </HtmlTooltip>
       </Typography>
       <input
        type="date"
        className="maindate"
        min={typeOfUser==="Admin"|| typeOfUser==="Approver" ? "": weekAhead()}
        style={{ padding: "11px" }}
        InputLabelProps={{ shrink: true }}
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        onKeyDown={(e) => e.preventDefault()}
        required
       />
      </Stack>
      <Stack
       className="mail-form-headers"
       sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginBottom: "10px",
       }}
      >
       <Typography sx={{ fontSize: "16px" }}>
        <span>
         End Date<span style={{ color: "red" }}>*</span>
        </span>
        <HtmlTooltip
         arrow
         title={
          <React.Fragment>
           <p>End Date should be ahead of Start Date</p>
          </React.Fragment>
         }
        >
         <img
          src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
          style={{ width: "6%", cursor: "pointer" }}
         />
        </HtmlTooltip>
       </Typography>
       <input
        type="date"
        min={typeOfUser==="Admin"|| typeOfUser==="Approver" ? "": weekAhead()}
        style={{ padding: "11px" }}
        InputLabelProps={{ shrink: true }}
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        onKeyDown={(e) => e.preventDefault()}
        required
       />
      </Stack>
     </div>
     <div className="mail-form-inner-wrap">
      <Stack
       className="mail-form-headers"
       sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginBottom: "10px",
       }}
      >
       <Typography sx={{ fontSize: "16px" }}>
        <span>Target Audience</span>
        <HtmlTooltip arrow title="Enter target audience for the campaign">
         <img
          src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
          style={{ width: "6%", cursor: "pointer" }}
         />
        </HtmlTooltip>
       </Typography>
       <WhiteBorderTextField
        // id="multiline"
        multiline
        minRows={1}
        maxRows={2}
        fullWidth
        placeholder="Eg: ASE, SE"
        variant="outlined"
        value={targetAudience}
        onChange={(e) => setTargetAudience(e.target.value)}
       />
      </Stack>
      <Stack
       className="mail-form-headers"
       sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginBottom: "10px",
       }}
      >
       <Typography sx={{ fontSize: "16px" }}>
        <span>
         #People Targeted<span style={{ color: "red" }}>*</span>
        </span>
        <HtmlTooltip arrow title="Enter number of people targeted by the campaign">
         <img
          src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
          style={{ width: "6%", cursor: "pointer" }}
         />
        </HtmlTooltip>
       </Typography>
       <WhiteBorderTextField
        fullWidth
        placeholder="Eg:1500"
        // id="multiline"
        multiline
        minRows={1}
        maxRows={2}
        variant="outlined"
        type="number"
        value={peopleTargeted}
        onChange={(e) => setPeopleTargeted(e.target.value)}
        required
       />
      </Stack>

      {/* <Grid item xs={12} md={6}>
          <input
            type="file"
            accept="image/*,.pdf,.doc,.docx" // Accept image, PDF, and doc files
            onChange={(e)=>setFile(e.target.files[0])}
            // required
         />
        </Grid> */}
      </div>
      </div>
      <Stack
       className="mail-form-headers"
       sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginBottom: "10px",
       }}
      >
         {onBehalfValue?
         <p style={{fontSize:"0.9rem",color:"##666666"}}>You are requesting on behalf of: <span style={{fontWeight:"bold"}}>
            {onBehalfValue}</span>
         <Button variant="text" sx={{ textTransform: 'none', textDecoration:"underline"}}
         onClick={()=>setOpenModal(true)}
         >Edit</Button>
         </p>
         :
         <p style={{fontSize:"0.9rem",color:"##666666"}}>Requesting on behalf of someone?
         <Button variant="text" sx={{ textTransform: 'none', textDecoration:"underline"}}
         onClick={()=>setOpenModal(true)}
         >Click here</Button>
         </p>
         }

      </Stack>
     
   </div>
   <div className="btn-container">
    <button
     type="submit"
     className={`${isVerified ? "" : "disabled"} mailer-generate-btn filled-btn next-btn`}
     disabled={!isVerified}
    >
     Next
    </button>
   </div>
   <instruct className="center instruction">
    <strong>Note:&nbsp;</strong>Make sure you click on "Verify" after entering the Name.
   </instruct>
  </Stack>

    <Modal open={openModal}>
      <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: "60vw",
                  bgcolor: 'background.paper',
                  boxShadow: 24,
                  p: 4,
                  borderRadius: 2,
                }}
              >
          <Typography variant="h6" component="h2" mb={2}>
             Select the person on behalf of whom you are requesting:
          </Typography>
         <Box my={1}>
          <Grid container >
             <Grid xs={6} id="autocomplete">
                <Autocomplete
                   required
                   options={inputValue.length > 0 ? UserMaintanenceData.map(user => user.Enterprise_ID) : []}
                   getOptionLabel={(option) => option}
                   value={onBehalfValue}
                   inputValue={inputValue} // Track the input value
                   onInputChange={(event, newInputValue) => setInputValue(newInputValue)} // Update inputValue
                   onChange={(event, newValue) => setOnBehalfValue(newValue)} // Update selected value
                   renderInput={(params) => <TextField {...params} label="Select Person" variant="outlined" />}
                   disablePortal
                   slotProps={{
                      popper: {
                         sx: {
                            '& .MuiAutocomplete-listbox': {
                               maxHeight: 100, // Set the max height
                               overflowY: 'auto', // Enable scrolling
                            },
                         },
                      },
                   }}
                />
             </Grid>
             <Grid xs={6} className="instruction" sx={{padding:"8px"}}>
                   <strong>Note: </strong>
                   <em>If the user or enterprise id does not exist then:
                      <br />
                      {/* 1. <span className="span-link" onClick={()=>setAddingNewEntId(true)}>Click here</span> to add the new user. */}
                      1. Request an Admin to add the user.
                      <br />
                      2. Select the newly added user in this input.
                   </em>
             </Grid>
          </Grid>
         </Box>
         <Grid xs={12} sx={{textAlign:"end"}}>
       <Button 
         sx={{padding:"3px", textTransform:"none"}}
         onClick={()=>{
         setOpenModal(false);
         setOnBehalfValue('');
         setInputValue('');
         }}>Cancel
       </Button>
       <Button variant="contained" onClick={handleBehalfUserSet}
         sx={{padding:"3px", textTransform:"none"}}
       >Set
       </Button>  
         </Grid>
       </Box>
    </Modal>
</>
 );
};

export default CampaignForm;
